import { render, staticRenderFns } from "./RmBatchTastePanelAttachments.vue?vue&type=template&id=a2bf9f2c&scoped=true&"
import script from "./RmBatchTastePanelAttachments.vue?vue&type=script&lang=js&"
export * from "./RmBatchTastePanelAttachments.vue?vue&type=script&lang=js&"
import style0 from "./RmBatchTastePanelAttachments.vue?vue&type=style&index=0&id=a2bf9f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bf9f2c",
  null
  
)

export default component.exports